import React, { useEffect, useState } from 'react';
export function StickyUrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    const endTimeKey = 'reinicio_biologico_end_time_15m';
    let endTime = localStorage.getItem(endTimeKey);
    if (!endTime) {
      endTime = (new Date().getTime() + 15 * 60 * 1000).toString();
      localStorage.setItem(endTimeKey, endTime);
    }
    const updateTimer = () => {
      const now = new Date().getTime();
      const distance = parseInt(endTime!) - now;
      if (distance < 0) {
        setTimeLeft({
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const minutes = Math.floor(distance / (1000 * 60));
      const seconds = Math.floor(distance % (1000 * 60) / 1000);
      setTimeLeft({
        minutes,
        seconds
      });
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-brand-red text-white text-xs sm:text-sm font-medium py-2 flex items-center justify-center px-4 shadow-md" data-id="element-347">
      <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center" data-id="element-348">
        <span className="text-[14px] font-[700]" data-id="element-349">
          ⚡ OFERTA ESPECIAL: Precio 26€ en lugar de 205€
        </span>
        <span className="text-[14px] font-[700] flex items-center gap-x-2" data-id="element-350">
          Acceso inmediato garantizado
          <span className="font-bold bg-black/20 px-2 py-0.5 rounded shrink-0" data-id="element-351">
            {formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)}
          </span>
        </span>
      </div>
    </div>;
}